// extracted by mini-css-extract-plugin
var _1 = "NotFoundContainer-YLM40";
var _2 = "NotFoundHeader-CJE9n";
var _3 = "NotFoundSubtitle-P2qR9";
var _4 = "NotFoundSubtitleContainer-FiayA";
var _5 = "NotFoundTitle-bmFeM";
export { _1 as "NotFoundContainer", _2 as "NotFoundHeader", _3 as "NotFoundSubtitle", _4 as "NotFoundSubtitleContainer", _5 as "NotFoundTitle" }
